import m from 'mithril';
import constants from '../lib/constants';
import app from '../app';

const vwClosed = {
	view: () => {
		return m('div', { class: 'container' }, [
			m('div', { class: 'card' }, [
				m('div', { class: 'card__decoration' }, [
					app.theme === constants.THEME_CHIRSTMAS
						? m('img', {
								src: constants.IMAGE_CHRISTMAS_GARLAND,
								alt: 'Christmas Hat',
								style: { height: '60px', 'object-fit': 'contain' },
						  })
						: m('img', { src: constants.IMAGE_ECOM_PAY, class: 'logo', alt: 'Ecom Pay Logo', style: { height: '60px', 'object-fit': 'contain', marginTop: '20px' } }),
				]),
				m('div', { class: 'card__upper' }, [
					m('div', { class: 'card__upper__content' }, [m('h2', 'Closed'), m('p', 'The payment session has been closed.')]),
				]),
				m('div', { class: 'card__lower' }, [
					m('div', { class: 'card__lower__content' }, [
						m('div', { class: 'payment-by' }, [m('span', 'Payment by'), m('img', { src: constants.IMAGE_ECOM_PAY, alt: 'Ecom Pay Logo' })]),
					]),
				]),
			]),
		]);
	},
};

export default vwClosed;
